import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { messageCenterService } from '_services';
import { ActionNames, Errors } from '_constants'

export const specProgReqActions = {
    load: () => dispatch => {
        dispatch(specProgReqActions.loadRequest());
        messageCenterService.loadSpecProgReqs()
            .then(
                messages => {
                    dispatch(specProgReqActions.loadSuccess(messages));
                },
                error => {
                    dispatch(specProgReqActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.SPEC_PROG_REQS_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.SPEC_PROG_REQS_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.SPEC_PROG_REQS_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.SPEC_PROG_REQS_LOAD_FAILURE),

    setSelectedMessage: createAction(ActionNames.SPEC_PROG_REQS_SET_SELECTED_MESSAGE),

    changeSelection: (nono) => (dispatch, getState) => {
        dispatch(specProgReqActions.setSelectedMessage({ nono }));


        if (!getState().entities.specProgReqMsgs[nono].isRead) {
            dispatch(specProgReqActions.markReadRequest({ nono }));

            messageCenterService.markReadNotification(nono)
                .then(
                    () => { dispatch(specProgReqActions.markReadSuccess(nono)) }
                    ,
                    error => {
                        dispatch(specProgReqActions.markReadFailure({ nono, error }));
                        dispatch(alertActions.error(Errors.SPEC_PROG_REQS_MARK_READ_FAILURE));
                    }
                );
        }
    },
    markReadRequest: createAction(ActionNames.SPEC_PROG_REQS_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.SPEC_PROG_REQS_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.SPEC_PROG_REQS_MARK_READ_FAILURE),

    reply: (sxno, reply, toUrno) => dispatch => {
        dispatch(specProgReqActions.replyRequest({ sxno }));

        messageCenterService.prwsReply(sxno, undefined, undefined, reply, toUrno)
            .then(
                () => { dispatch(specProgReqActions.replySuccess(sxno)) }
                ,
                error => {
                    dispatch(specProgReqActions.replyFailure({ sxno, error }));
                    dispatch(alertActions.error(Errors.SPEC_PROG_REQS_REPLY_FAILURE));
                }
            );
    },
    replyRequest: createAction(ActionNames.SPEC_PROG_REQS_REPLY_REQUEST),
    replySuccess: createAction(ActionNames.SPEC_PROG_REQS_REPLY_SUCCESS),
    replyFailure: createAction(ActionNames.SPEC_PROG_REQS_REPLY_FAILURE),

    toggleReply: createAction(ActionNames.SPEC_PROG_REQS_TOGGLE_REPLY),



}
